import React from 'react';
import { useTranslation } from 'react-i18next';

import { useNavigation } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';

import CreditIcon from '@/assets/icons/credit';
import { AnalyticsEvent } from '@/feature/analytics/constants';
import { useDepositAmountConverter } from '@/feature/devsettings/hooks/use-dev-settings';
import { useJurisdictionStore } from '@/hooks/use-jurisdiction';
import { DepositStackParamList } from '@/navigation/types';

import { setDepositAmount, useDepositStatusStore } from '../hooks/use-deposit-status-store';
import { AddPaymentMethod } from './AddPaymentMethod';
import { FastestTag } from './FastestTag';

type PaymentMethodDebitCardProps = {
    paysafeAccountId: string;
    canUse3ds: boolean;
};

export const AddPaymentMethodDebitCard = ({ paysafeAccountId, canUse3ds = false }: PaymentMethodDebitCardProps) => {
    const selectedAmount = useDepositStatusStore(state => state.selectedAmount);
    const navigation = useNavigation<NativeStackNavigationProp<DepositStackParamList>>();
    const content = useJurisdictionStore(store => store.jurisdictionSettings?.productConfig?.keyValuePairs);

    const cmsContent = content?.['Content Keys'];
    const { t } = useTranslation('transactions');
    const { convertToMinorUnitAmount } = useDepositAmountConverter();

    return (
        <AddPaymentMethod
            icon={<CreditIcon />}
            title={t('add_debit_card')}
            description={cmsContent?.['deposit.debitCard.description'] ?? ''}
            tag={<FastestTag />}
            onPress={() => {
                setDepositAmount(convertToMinorUnitAmount(selectedAmount));
                navigation.navigate('AddDebitCardWebView', {
                    paysafeAccountId,
                    canUse3ds,
                });
            }}
            analyticsEvent={AnalyticsEvent.DEPOSIT_METHOD_ADD_DEBIT}
        />
    );
};
